var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"myContainerGalerie"},[_c('TitreDePage',{attrs:{"titre":_vm.$t('Titre.Galerie.Vegetale')}}),_c('GaleriePhotos',{attrs:{"imageInGaleries":_vm.coolLightBoxItems}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }